$(function(){

	function getParameterByName( name ) {
      name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
      var regexS = "[\\?&]"+name+"=([^&#]*)";
      var regex = new RegExp( regexS );
      var results = regex.exec( window.location.href );
      if( results == null )
        return "";
      else
        return decodeURIComponent(results[1].replace(/\+/g, " "));
    }

	$(document).on('click', '.j-toggle-megamenu', function(e){

		e.preventDefault();
		$(this).parent().find('.megamenu').toggleClass('expand');

	});

	$(document).on('click', '.mobile-menu-container .j-mobile-list-set-title', function(){

		$(this).parent().find('.ul-wrap').addClass('expand');

	});

	$(document).on('click', '.mobile-menu-container .j-mobile-menu-back-link', function(e){

		e.preventDefault();
		$(this).parent().removeClass('expand');

	});

	$(document).on('click', '.mobile-menu-container .j-mobile-menu-back-link', function(e){

		e.preventDefault();
		$(this).parent().removeClass('expand');

	});

	$(document).on('click', '.mobile-menu-container .j-mobile-occasion-title', function(e){

		e.preventDefault();
		$(this).parent().find('.occasion-grid').addClass('expand');

	});

	$(document).on('click', '.j-expand-mobile-menu', function(e){

		e.preventDefault();
		$('.site-header .mobile-menu-container').addClass('expanded');

	});

	$(document).on('click', '.j-close-mobile-menu', function(e){

		e.preventDefault();
		$('.site-header .mobile-menu-container').removeClass('expanded');
		$('.mobile-menu-container .occasion-grid').removeClass('expand');
		$('.mobile-menu-container .ul-wrap').removeClass('expand');
		$('.mobile-menu-container .megamenu').removeClass('expand');

	});

	$(document).on('click', '.template-product .product-info-bottom_row_z .product-info-row_head', function(e){

		e.preventDefault();
		//$('.template-product .product-info-bottom_row_z .product-info-row_head').removeClass('expanded')
		$(this).parent().siblings().find('.product-info-row_text').slideUp();
		$(this).parent().siblings().find('.product-info-row_head').removeClass('expanded');
		$(this).toggleClass('expanded').parent().find('.product-info-row_text').slideToggle();


	});

	if ( $('.blog-articles_component').length > 0 ) {

		var blog_filters = $('.blog-articles_component .blog-cat-tabs').offset().top;

		$(window).scroll(function() {
		    if ( $(this).scrollTop() >= blog_filters ) {
		        console.log('is in top');
		        $('.blog-cat-tabs').addClass('switch');
		    } else {
		        console.log('is not in top');
		        $('.blog-cat-tabs').removeClass('switch');
		    }
		});

		$(document).on('click', '.j-toggle-bp-cat', function(e){

			e.preventDefault();
			var category = $(this).data('cat');
			console.log('category', category);

			$('.j-toggle-bp-cat').removeClass('active');
			$('.j-toggle-bp-cat[data-cat="' + category + '"]').addClass('active');

			if ( category == 'all' ){
				$('.blog-articles-collection').removeClass('filtered');
			} else {
				$('.blog-articles-collection').addClass('filtered');
			}

			$('.blog-articles-collection .blog-articles-item').removeClass('visible');
			$('.blog-articles-collection .blog-articles-item.j-cat-' + category + '').addClass('visible');

			if ($(window).width() < 991) {

				$('.j-toggle-bp-filters').removeClass('expanded').siblings().slideUp();

			}

		});

	}

	$(document).on('click', '.j-scroll-to-top', function(e){

		e.preventDefault();
		console.log('scroll to top');
		$("html, body").animate({
			scrollTop: $("body").offset().top
		}, 500);


	});

	$(document).on('click', '.j-toggle-bp-filters', function(e){

		e.preventDefault();
		$(this).toggleClass('expanded').siblings().slideToggle();

	});

	$(document).on('click', '.j-scroll-to-letter', function(e){

		e.preventDefault();

		var letter = $(this).data('letter');
		$("html, body").animate({
			scrollTop: $('.designer-listing .break[data-letter="' + letter + '"]').offset().top - 100
		}, 500);


	});


	$(document).on('click', '.j-toggle-account-form', function(e){

		e.preventDefault();
		var form = $(this).data('modal');

		$('.customer-entrance-template .form-wrapper').hide();
		$('.customer-entrance-template .form-wrapper[data-modal="' + form + '"]').show();



	});

	$('.j-logo-carousel').slick({
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 4,
		autoplay: true,
		arrows: false,
		dots: false,
		fade: false,
		cssEase: 'linear',
		swipeable: false,
		autoplaySpeed: 3000,
		speed: 600,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}
		]
	});


	if ($(window).width() > 991) {

		$('.j-occasions-carousel').slick({
			infinite: true,
			slidesToShow: 4,
			slidesToScroll: 1,
			autoplay: false,
			arrows: true,
			dots: false
		});

	}


	//if ($(window).width() > 1024) {

		setTimeout(function(){
			$('.j-logo-carousel .slick-slide').addClass('opacidown');
		},2400);

		$('.j-logo-carousel').on('afterChange', function(event, slick, currentSlide, nextSlide){
			$('.j-logo-carousel .slick-slide').removeClass('opacidown');
			setTimeout(function(){
				$('.j-logo-carousel .slick-slide').addClass('opacidown');
			},2400);
		});

	//}

	$(document).on('click', '.j-toggle-sorting-children', function(e){

		e.preventDefault();
		$(this).toggleClass('expanded').parent().find('.filters-sorting').slideToggle();

	});

	if ($(window).width() < 991) {

		$(document).on('click', '.j-toggle-filter-children', function(e){

			e.preventDefault();
			$(this).toggleClass('expanded').parent().find('.filter-wrapper').slideToggle();

		});

	}

	$(document).on('click', '.j-occasion-filter-trigger', function(){

		console.log('trigger');

		var input = $(this).find('input');
		input.prop("checked", !input.prop("checked"));

	});

	$(document).on('click', '.j-trigger-drift-chat', function(e){

		e.preventDefault();
		drift.api.openChat();
		$('#drift-frame-controller').show();

	});

	drift.on('ready',function(api, payload) {
		drift.on('chatClose',function(e){
			$('#drift-frame-controller').hide();
		})
	})

	$(document).on('click', '.j-disabled-checkout', function(e){

		e.preventDefault();

	});

	$(document).on('change', '#terms-accept', function(){

		if ($(this).is(':checked')) {

			console.log('is checked');
			$('.checkout-button').removeClass('disabled j-disabled-checkout');
			$('.terms-toggle-wrapper').addClass('is-checked');

		} else {

			console.log('is NOT checked');
			$('.checkout-button').addClass('disabled j-disabled-checkout');
			$('.terms-toggle-wrapper').removeClass('is-checked');

		}

	});


	// $(document).on('click', '.j-product-variant-image-item', function(){

	// 	var scrollTo = $(this).data('imagesrc');
	// 	// console.log(scrollTo);

	// 	// $("html, body").animate({
	// 	// 	scrollTop: $('.product_other-image[data-imagename="' + scrollTo + '"]').offset().top
	// 	// }, 500);

	// 	// var scroll = new LocomotiveScroll();
	//  //    var target = $('.product_other-image[data-imagename="' + scrollTo + '"]');

	//  //    console.log('target', target);

	//  //    scroll.scrollTo(target);

	// });

	//Start Intercom script

	// window.intercomSettings = {
	//     api_base: "https://api-iam.intercom.io",
	//     app_id: "r9yuanvm"
	// };

	// // We pre-filled your app ID in the widget URL: 'https://widget.intercom.io/widget/r9yuanvm'
	// (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/r9yuanvm';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();

	// Intercom('boot', {  
	//     app_id: 'r9yuanvm'
	// });

	// $(document).on('click', '.j-chat-toggle', function(e){

	// 	e.preventDefault();
	// 	Intercom('show');

	// });

	function sanitizeMCreponse(resp){
		var msg = "";

		var index = -1;
		try {
			var parts = resp.msg.split(' - ', 2);
			if (parts[1] === undefined) {
				msg = resp.msg;
			} else {
				var i = parseInt(parts[0], 10);
				if (i.toString() === parts[0]) {
					index = parts[0];
					msg = parts[1];
				} else {
					index = -1;
					msg = resp.msg;
				}
			}
		}
		catch (e) {
			index = -1;
			msg = resp.msg;
		}
		return msg;
	}

	if ( $('.mc-ajax-signup').length > 0 ){

		// $(document).on('submit', '.mc-ajax-signup', function(e){
		// 	e.preventDefault();
		// });

		var audience_url = 'https://loanthelook.us5.list-manage.com/subscribe/post?u=63068964208dddf02ec61fb80&amp;id=4ed06e2221';

		$('.mc-ajax-signup').ajaxChimp({	
		    url: audience_url,
		    callback: function (resp) {
		        console.log(resp);
		        if (resp.result === "success") {

		        	$('.mc-ajax-signup input, .mc-ajax-signup .in-loop_form-chkbx-wrapper').hide();
		        	$('.mc-ajax-signup .mc-message.error').hide().html('');
		        	$('.mc-ajax-signup .mc-message.success').show().html(resp.msg);
		            
		        } else {
		            console.log(resp.msg);

		        	$('.mc-ajax-signup .mc-message.success').hide().html('');

		        	var msg = sanitizeMCreponse(resp);

					if( msg.includes("is already subscribed") ) {
						$('.mc-ajax-signup .mc-message.error').show().html('You are already subscribed');
					} else  {
						$('.mc-ajax-signup .mc-message.error').show().html(resp.msg);
					}

		        }
		    }
		});

		$(document).on('change', '#SitL-Check', function(){

			if ($(this).is(':checked')) {

				console.log('is checked');
				$('.mc-ajax-signup .mc-submit-btn').removeClass('disabled');

			} else {

				console.log('is NOT checked');
				$('.mc-ajax-signup .mc-submit-btn').addClass('disabled');

			}

		});

	}

	// Start modal newsletter

	if ( $('.mc-ajax-signup-modal').length > 0 ){

		var audience_url = 'https://loanthelook.us5.list-manage.com/subscribe/post?u=63068964208dddf02ec61fb80&amp;id=4ed06e2221';

		$('.mc-ajax-signup-modal').ajaxChimp({	
		    url: audience_url,
		    callback: function (resp) {
		        console.log(resp);
		        if (resp.result === "success") {

		        	$('.mc-ajax-signup-modal input, .mc-ajax-signup-modal .in-loop_form-chkbx-wrapper').hide();
		        	$('.mc-ajax-signup-modal .mc-message.error').hide().html('');
		        	$('.mc-ajax-signup-modal .mc-message.success').show().html(resp.msg);
		        	Cookies.set('newsletter_modal', 'true', { expires: 365 });
		            
		        } else {
		            console.log(resp.msg);

		        	$('.mc-ajax-signup-modal .mc-message.success').hide().html('');

		        	var msg = sanitizeMCreponse(resp);

					if( msg.includes("is already subscribed") ) {
						$('.mc-ajax-signup-modal .mc-message.error').show().html('You are already subscribed');
					} else  {
						$('.mc-ajax-signup-modal .mc-message.error').show().html(resp.msg);
					}

		        }
		    }
		});

		$(document).on('change', '#modal-checkbox-input', function(){

			if ($(this).is(':checked')) {

				console.log('is checked');
				$('.mc-ajax-signup-modal .mc-submit-btn').removeClass('disabled');

			} else {

				console.log('is NOT checked');
				$('.mc-ajax-signup-modal .mc-submit-btn').addClass('disabled');

			}

		});

		var newsletter_modal = Cookies.get('newsletter_modal');
		var modal_timeout = $('.mc-ajax-signup-modal').data('timeout');
		var modal_timeout_ms = modal_timeout*1000;
	        
	    if(newsletter_modal == undefined) {

	        console.log('newsletter_modal undefined');
	        setTimeout(function(){
	            $('.newsletter-modal').fadeIn();
	        }, modal_timeout_ms);

	    }

	    $(document).on('click', '.j-close-newlsetter-modal', function(e){

	        e.preventDefault();
	        $(this).parent().fadeOut();
	        Cookies.set('newsletter_modal', 'true', { expires: 365 });

	    });

	}

	$(document).on('click', '#vue-storefront-listing .pagination-wrapper .pagination li a', function(){

		$("html, body").animate({
			scrollTop: $("body").offset().top
		}, 500);	

	});

	$(document).on('click', '.j-close-cookie-modal', function(e){

        e.preventDefault();
        $('.cookie-modal').fadeOut();
        Cookies.set('cookie_box', 'true', { expires: 365 });

    });

    // Set cookie for cookie policy modal

    var cookie_box = Cookies.get('cookie_box');

    if(cookie_box == undefined) {

        console.log('cookie_box undefined');
        setTimeout(function(){
            $('.cookie-modal').fadeIn();
        }, 3000);

    }

	// if ($(window).height() < 720) {

	// 	console.log('< 720');
	// 	$('#product-booking-app-container').addClass('kill-transform');

	// }

	$(document).on('click', '.j-toggle-search-modal', function(e){

		e.preventDefault();
		$('.j-search-modal').slideToggle();

	});

	if ($(window).width() < 767) {

		$(window).scroll(function() {

			var chat_home = $('.template-index .chat-icon-global'),
		        top = $(document).scrollTop();
		    if (top > 400){
		        chat_home.fadeIn();
		        console.log('fadeIn');
		    } else {
		    	chat_home.fadeOut();
		    	console.log('fadeOut');
		    }

		});

	}

	$(document).on('click', '.in-loop_form-wrapper .mc-submit-btn, .newsletter-modal .inner .mc-ajax-signup-modal .button', function(){

		$(this).addClass('disabled');
		console.log('disabled class added');

	});

	function open_cart() {	

		$('.w-commerce-commercecartwrapper.cart').attr('data-cart-open', '');
		$('.w-commerce-commercecartcontainerwrapper.w-commerce-commercecartcontainerwrapper--cartType-rightSidebar').show();
		$('.w-commerce-commercecartcontainer').css('transform', 'translateX(0px)').css( 'transition', 'transform 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s');

	}

	var accountTab = getParameterByName("account");

    if ( document.location.href.indexOf('&opencart') > -1 ) {

	    console.log('Open Cart');
	    open_cart();

	  }

	setTimeout(function(){
		$('body').css('opacity', 1);
		$('[data-anim="fade"]').css('opacity', 1).css('transform', 'unset');
	},3000);

	$(document).on('click', '.j-add-giftbox-cart', function(e){

		e.preventDefault();
		var _this = $(this);
		var button_text = $(this).text();

  		var selectedVariant = getParameterByName("variant");
  		var recipient = $('#recipient').val();
  		var sender = $('#sender').val();
  		var properties = { Recipient: recipient, Sender: sender };

  		console.log(selectedVariant);
  		console.log(recipient);

        CartJS.addItem(selectedVariant, 1, properties, {
            "success": function(data, textStatus, jqXHR) {
                console.log('added to basket');
                _this.html('Added!');

                setTimeout(function(){
                	_this.html(button_text);
                	location.reload();
				}, 1000);

            },
            "error": function(jqXHR, textStatus, errorThrown) {
                console.log('cart js Error');
                _this.html('An error occurred');
            }
        });

	});

	$(document).on('click', '.j-variant-selection', function(e){

		e.preventDefault();
		$(this).addClass('active').siblings().removeClass('active');

		var vid = $(this).data('vid');
		console.log(vid);
		const url = new URL(window.location);
		url.searchParams.set('variant', vid);
		window.history.pushState({}, '', url);

	});

	$(document).on('click', '.j-buy-now-btn', function(e){

		e.preventDefault();
		var _this = $(this);

  		var selectedVariant = getParameterByName("variant");
  		var recipient = $('#recipient').val();
  		var sender = $('#sender').val();
  		var properties = { Recipient: recipient, Sender: sender };

  		console.log(selectedVariant);
  		console.log(recipient);

        CartJS.addItem(selectedVariant, 1, properties, {
            "success": function(data, textStatus, jqXHR) {
                console.log('added to basket');
                _this.html('Checking out...');
                window.location.replace("/checkout");

            },
            "error": function(jqXHR, textStatus, errorThrown) {
                console.log('cart js Error');
                _this.html('An error occurred');
            }
        });

	});
	

});